export const ProtocolWorldsFolderName = "Protocol Worlds";
